import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_TRANSFERDETAIL,
  DELETE_TRANSFERDETAIL,
  UPDATE_TRANSFERDETAIL,
  ADD_NEW_TRANSFERDETAIL,
} from "./actionType";

import {
  getTransferDetailSuccess,
  getTransferDetailFail,
  deleteTransferDetailSuccess,
  deleteTransferDetailFail,
  updateTransferDetailSuccess,
  updateTransferDetailFail,
  addTransferDetailSuccess,
  addTransferDetailFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveTransferDetailApi,
  getTransferDetailApi,
  updateTransferDetailApi,
  deleteTransferDetailApi,
  addNewTransferDetailApi
} from "../../helpers/backend_helper";

function* getTransferDetail({ payload: transferDetail }) {
  try {
    const response = yield call(getTransferDetailApi, transferDetail);
    yield put(getTransferDetailSuccess(GET_TRANSFERDETAIL, response.data));
  } catch (error) {
    yield put(getTransferDetailFail(GET_TRANSFERDETAIL, error));
  }
}

function* onUpdateTransferDetail({ payload: transferDetail }) {
  try {
    if (transferDetail.setApprove) {
      const response = yield call(approveTransferDetailApi, transferDetail);
      yield put(updateTransferDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateTransferDetailApi, transferDetail);
      yield put(updateTransferDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateTransferDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteTransferDetail({ payload: transferDetail }) {
  try {
    const response = yield call(deleteTransferDetailApi, transferDetail);
    yield put(deleteTransferDetailSuccess({ transferDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteTransferDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewTransferDetail({ payload: transferDetail }) {
  try {
    const response = yield call(addNewTransferDetailApi, transferDetail);
    yield put(addTransferDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addTransferDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetTransferDetail() {
  yield takeEvery(GET_TRANSFERDETAIL, getTransferDetail);
}

export function* watchUpdateTransferDetail() {
  yield takeEvery(UPDATE_TRANSFERDETAIL, onUpdateTransferDetail);
}

export function* watchDeleteTransferDetail() {
  yield takeEvery(DELETE_TRANSFERDETAIL, onDeleteTransferDetail);
}

export function* watchAddNewTransferDetail() {
  yield takeEvery(ADD_NEW_TRANSFERDETAIL, onAddNewTransferDetail);
}

function* transferDetailSaga() {
  yield all([
    fork(watchGetTransferDetail),
    fork(watchDeleteTransferDetail),
    fork(watchUpdateTransferDetail),
    fork(watchAddNewTransferDetail)
  ]);
}

export default transferDetailSaga;
